
<template>
  <div class = wrapper id = "container">
    <div class = "referralContainer">
        <div class = "referralSubContainer" @click="shareReferral">
            <p class = "inviteText">Invite a friend & both of you earn 1% bonus</p>
            <img class = "notificationImage" src = "/img/notification-icon.svg">
        </div>
    </div>
    <div class = "earnings_wrapper">
        <div class = "earning-circle circle-res" :class="{ activeMethod: selectedItem === 'earnings'}" @click="selectedMethod('earnings')">
            <div v-if = "isEarningExpected && (!earnings && expectedEarnings !== null && earningsEmptyState)" class = "circle-txt" style = "top: 38%;">
                <p class = "earnings-value-text"><span class = "rupeeSymbol">₹</span>{{expectedEarnings/100 | localeAmount }}</p>
                <p class = "earnings-value-static">Upcoming Earnings</p>
                <p class = "earnings-value-apr">
                    <v-icon class="material-icons-round bannerIcons">trending_up</v-icon>
                {{aprData}}% p.a.</p>
            </div>
            <div v-else-if = "!earnings && expectedEarnings === null && earningsEmptyState" class = "circle-txt-earnings">
                <img id = "earnings_image"/>
                <p class = "additional-text">Your investment is being deployed</p>
            </div>
            <div v-else-if = "!earnings && expectedEarnings !== null && earningsEmptyState" class = "circle-txt">
                <p class = "earnings-value-text"><span class = "rupeeSymbol">₹</span>{{expectedEarnings/100 | localeAmount }}</p>
                <p class = "earnings-value-static">First Expected Earnings</p>
            </div>
            <div v-else-if = "earnings && earningsEmptyState || isEarningExpected" class = "circle-txt" style = "top: 38%;">
                <p class = "earnings-value-text"><span class = "rupeeSymbol">₹</span>{{earnings | localeAmount }}</p>
                <p class = "earnings-value-static">Total Earnings</p>
                <p class = "earnings-value-apr">
                    <v-icon class="material-icons-round bannerIcons">trending_up</v-icon>
                {{aprData}}% p.a.</p>
            </div>
        </div>
        <div class = "loans_wrapper">
            <div class = "loans-circle circle-res" :class="{ activeMethod: selectedItem === 'loans'}" @click="selectedMethod('loans')">
                <div class = "circle-txt">
                    <p v-show = "loanCount" class = "account-value-text">{{loanCount | localeAmount}}</p>
                    <p style = "padding-left: 7px; padding-right: 7px" class = "account-value-static" :class="emptyLoans">Borrowers Impacted</p>
                    <p style = "padding-left: 9px; padding-right: 9px" v-show = "!loanCount" class = "space_text">Watch this space</p>
                </div>
            </div>
        </div>
        <div class = "reward_wrapper">
            <div class = "reward-circle circle-res" :class="{ activeMethod: selectedItem === 'reward'}" @click="selectedMethod('reward')">
                <div class = "circle-txt">
                    <p class = "account-value-text"><span class = "rupeeSymbolSmall">₹</span>{{rewardAmount | localeAmount }}</p>
                    <p class = "account-value-static">Rewards</p>
                </div>
            </div>
        </div>
        <div class = "account_wrapper">
            <div class = "account-circle circle-res" :class="{ activeMethod: selectedItem === 'account'}" @click="selectedMethod('account')">
                <div class = "circle-txt">
                    <p class = "account-value-text"><span class = "rupeeSymbolSmall">₹</span>{{totalAccountValue | localeAmount }}</p>
                    <p class = "account-value-static">Account Value</p>
                </div>
            </div>
        </div>
        <div class = "invest_wrapper">
            <div class = "invest-circle circle-res" :class="{ activeMethod: selectedItem === 'investment'}" @click="selectedMethod('investment')">
                <div class = "circle-txt">
                    <p class = "account-value-text"><span class = "rupeeSymbolSmall">₹</span>{{ (growthInvestmentAmount + incomeInvestmentAmount) / 100 | localeAmount }}</p>
                    <p class = "account-value-static">Invested</p>
                </div>
            </div>
        </div>
        <div class = "normal_circle_1"></div>
        <div class = "normal_circle_2"></div>
        <div class = "normal_circle_3"></div>
        <div class = "normal_circle_4"></div>
    </div>
    <div v-if = "dataLoaded" class = "sub-component">
        <component v-bind:is="currentTabComponent"
        :loanCount="loanCount"
        :rewardAmount="rewardAmount"
        :earnings="earnings"
        :expectedEarnings="expectedEarnings"
        :escrowBalance="escrowBalance"
        :growthInvestment = "growthInvestmentAmount"
        :incomeInvestment = "incomeInvestmentAmount"
        ></component>
    </div>
        <v-snackbar v-model="isCopied" app timeout="3000">
            Copied to clipboard!
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="isCopied = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import lenderService from '@/services/lenderService'
import rewardComponent from '@/components/dashboard/rewardStates.vue'
import loanComponent from '@/components/dashboard/loanState.vue'
import accountValueComponent from '@/components/dashboard/accountValue.vue'
import earningsComponent from '@/components/dashboard/earningsState.vue'
import investmentComponent from '@/components/dashboard/investmentState.vue'
export default {
    components: {
        rewardComponent,
        loanComponent,
        accountValueComponent,
        earningsComponent,
        investmentComponent
    },
    data () {
        return {
            growthInvestmentAmount: null,
            incomeInvestmentAmount: null,
            isCopied: false,
            selectedItem: '',
            totalAccountValue: null,
            rewardAmount: null,
            loanCount: null,
            earnings: null,
            currentTabComponent: null,
            dataLoaded: false,
            expectedEarnings: null,
            aprData: null,
            earningsEmptyState: false,
            escrowBalance: null,
            isEarningExpected: false
        }
    },
    computed: {
        emptyLoans () {
            if (this.loanCount === 0) {
                return 'emptyLoans'
            }
            return 'account-value-static'
        }
    },
    mounted () {
        this.selectedItem = 'earnings'
        this.currentTabComponent = 'earningsComponent'
        const chartDetails = this.$store.getters['dashboard/getChartDetails']
        this.totalAccountValue = chartDetails.totalAccountValue + chartDetails.pendingAmount
        this.escrowBalance = chartDetails.escrowBalance
        this.generatedReferralCode = this.$store.state.dashboard.generatedReferralCode
        this.mainDashboardData()
        window.scrollTo(0, document.body.scrollHeight)
    },
    methods: {
        shareReferral () {
            navigator.clipboard.writeText(
                `Join me to invest in loans curated by IndiaP2P and earn up to 18% returns on your investments. IndiaP2P is an RBI certified NBFC- P2P. Create your account using this link here: https://invest.indiap2p.com/register?ref=${this.generatedReferralCode}`
            )
            this.isCopied = true
            if (navigator.share) {
                // Web Share API is supported
                navigator
                    .share({
                        title: 'IndiaP2P Invest',
                        text:
                            'Join me to invest in loans curated by IndiaP2P and earn up to 18% returns on your investments. IndiaP2P is an RBI certified NBFC- P2P. Create your account using this link here: https://invest.indiap2p.com/register?ref=' +
                            this.generatedReferralCode
                    })
            } else {
                // Fallback
                navigator.clipboard
                    .writeText(
                        `Join me to invest in loans curated by IndiaP2P and earn up to 18% returns on your investments. IndiaP2P is an RBI certified NBFC- P2P. Create your account using this link here: https://invest.indiap2p.com/register?ref=${this.generatedReferralCode}`
                    )
                    .then(() => {
                        this.isCopied = true
                    })
            }
        },
        selectedMethod (option) {
            this.selectedItem = option
            if (this.selectedItem === 'earnings') {
                this.currentTabComponent = 'earningsComponent'
            } else if (this.selectedItem === 'loans') {
                this.currentTabComponent = 'loanComponent'
            } else if (this.selectedItem === 'reward') {
                this.currentTabComponent = 'rewardComponent'
            } else if (this.selectedItem === 'account') {
                this.currentTabComponent = 'accountValueComponent'
            } else if (this.selectedItem === 'investment') {
                this.currentTabComponent = 'investmentComponent'
            } else {
                this.currentTabComponent = ''
            }
            window.scrollTo(0, document.body.scrollHeight)
        },
        async mainDashboardData () {
            this.$store.commit('isLoading')
            const response = await Promise.all([
                lenderService.getMainDashboardData(),
                lenderService.getExpectedEarningsData(),
                lenderService.earningsSummaryData()
            ])
            const dashboardData = response[0]
            const expectedEarningsData = response[1]
            const earningsSummary = response[2]
            this.$store.commit('isNotLoading')
            if (dashboardData.status === 200) {
                this.earnings = dashboardData.data.earningsData / 100
                this.rewardAmount = dashboardData.data.rewardData / 100
                this.loanCount = dashboardData.data.loanCount
                this.growthInvestmentAmount = dashboardData.data.growthInvestment
                this.incomeInvestmentAmount = dashboardData.data.incomeInvestment
                if (dashboardData.data?.apr) {
                    this.aprData = Math.round(dashboardData.data.apr)
                }
            }
            if (expectedEarningsData.status === 200) {
                if (expectedEarningsData.data[0]?.repaymentData[0]?.expectedEarnings !== 0 && expectedEarningsData.data[0]?.repaymentData[0]?.expectedEarnings) {
                    this.expectedEarnings = expectedEarningsData.data[0].repaymentData[0].expectedEarnings
                    this.isEarningExpected = expectedEarningsData.data[0].isEarningExpected
                }
                this.dataLoaded = true
                this.earningsEmptyState = true
            }

            if (earningsSummary.status === 200) {
                this.earnings = (earningsSummary.data.growth.paidInterest + earningsSummary.data.income.paidInterest) / 100
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.rupeeSymbol {
    font-size: 25px
}

.rupeeSymbolSmall {
    font-size: 21px
}
.notificationImage {
    width: 20%;
    height: auto;
}
.inviteText {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: 400;
    font-size: 17px;
    text-align: left;
    color: #FFFFFF;
}
.referralSubContainer {
    cursor: pointer;
    height: 60px;
    width: 60% !important;
    padding: 10px;
    padding-left: 20px;
    padding-right: 20px;
    background: #13285E;
    border-radius: 12px;
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.referralContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 90px;
}
.bannerIcons {
    color: #002fa7;
    font-size: 20px
}
.emptyLoans {
    margin-top: 0% !important;
}

    p {
        margin-bottom: 0px !important;
    }

  #earnings_image {
    content: url('/img/Earnings-light.svg');
    width: 60% ;
    height: auto;
  }
.space_text {
    color: #002fa7;
    margin-top: 8%;
    font-weight: 500;
    font-size: 12px;
}
.additional-text {
    line-height: normal;
    margin-top: 7%;
    margin-left: 4%;
    margin-right: 4%;
    font-weight: 400;
    font-size: 17px;
    color: #002fa7;
}
.account-value-static {
    line-height: normal;
    margin-top: 12%;
    font-weight: 400;
    font-size: 15px;
    color: #002fa7;
}
.earnings-value-static {
    line-height: normal;
    margin-top: 12%;
    font-weight: 400;
    font-size: 17px;
    color: #002fa7;
}
.earnings-value-apr {
    margin-top: 8%;
    font-weight: 700;
    font-size: 20px;
    color: #002fa7;
}
.account-value-text {
    font-size: 24px;
    color: #002fa7;
    font-weight: 600;
}
.earnings-value-text {
    font-size: 30px;
    color: #002fa7;
    font-weight: 500;
}
.sub-component {
    margin-top: calc(25% - 60px);
    display: flex;
    flex-direction: column;
    align-items: center;
}
.circle-res {
  border-radius: 50%;
  box-shadow: 10px 20px 70px #ffcb05 inset;
  line-height: 0;
  position: relative;
  background: #fffae7;
  cursor: pointer;
  -webkit-transition: all 1s ease-out;
  -moz-transition: all 1s ease-out;
  -o-transition: all 1s ease-out;
  transition: all 1s ease-out;
}
.loans-circle {
  width: 14%;
  height: 14%;
}
.account-circle {
  width: 15%;
  height: 15%;
}
.reward-circle {
  width: 11%;
  height: 11%
}
.invest-circle {
    width: 14%;
    height: 14%;
}

.earning-circle {
    z-index: 2;
    height: 22%;
    width: 22%;
}
.circle-res::after {
  content: "";
  display: block;
  padding-bottom: 100%;
  -webkit-transition: all 2s ease-out;
  -moz-transition: all 2s ease-out;
  -o-transition: all 2s ease-out;
  transition: all 2s ease-out;
}
.circle-txt {
    position: absolute;
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 40%;
}
.circle-txt-earnings {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 10%;
}

.circle-res:hover {
  background-color: #fffae7;
  box-shadow: none;
}

.activeMethod {
  background: linear-gradient(#13285e 100%, #071A90 00.00%);
  border: none;
  box-shadow: none;

    .bannerIcons {
        color: #1FED58
    }
  .circle-txt {
    color: #ffffff
  }
  .account-value-static {
    color: #ffffff;
  }
.account-value-text {
    color: #ffffff;
  }
  .additional-text {
    color: #ffffff;
  }
  .earnings-value-text {
    color: #ffffff;
  }
    .earnings-value-static {
    color: #ffffff;
  }
  .earnings-value-apr {
    color: #1FED58;
    }
    #earnings_image {
        content: url('/img/main-dashboard-dark.svg')
  }
  .earnings-value-text {
        font-weight: 600;
    }
}

.earnings_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding-top:10%;
    width: 100%;
}
.loans_wrapper {
    z-index: 3;
    position: absolute;
    top: -9%;
    left: 50%;
    width: 100%;
}
.reward_wrapper {
    z-index: 3;
    position: absolute;
    top: 50%;
    left: 63%;
    width: 100%;
}
.account_wrapper {
    position: absolute;
    top: 95%;
    left: 30%;
    width: 100%;
}
.invest_wrapper {
    z-index: 1;
    position: absolute;
    top: 22%;
    left: 25%;
    width: 100%;
}
.wrapper {
    align-items: center;
    min-height: 100%;
}

.normal_circle {
    position: absolute;
    top: 28%;
    left: 27%;
    height: 8vw;
    width: 8vw;
    background: #030092 10%;
    opacity: 0.1;
    box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
    border-radius: 50%;
    display: inline-block;
}
.normal_circle_1 {
    position: absolute;
    top: 95%;
    left: 55%;
    height: 6vw;
    width: 6vw;
    background: #030092 10%;
    opacity: 0.1;
    box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
    border-radius: 50%;
    display: inline-block;
}
.normal_circle_2 {
    position: absolute;
    top: 13%;
    left: 42%;
    height: 4vw;
    width: 4vw;
    background: #030092 10%;
    opacity: 0.1;
    box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
    border-radius: 50%;
    display: inline-block;
}
.normal_circle_3 {
    position: absolute;
    top: 85%;
    left: 65%;
    height: 2vw;
    width: 2vw;
    background: #030092 10%;
    opacity: 0.1;
    box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
    border-radius: 50%;
    display: inline-block;
}
.normal_circle_4 {
    position: absolute;
    top: 80%;
    left: 30%;
    height: 2vw;
    width: 2vw;
    background: #030092 10%;
    opacity: 0.1;
    box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
    border-radius: 50%;
    display: inline-block;
}
@media (max-width: 1200px) {
    .account-value-static {
        margin-top: 7%;
        font-size: 15px;
    }
    .account-value-text {
        font-size: 18px;
    }
    .earnings-value-static {
        margin-top: 7%;
        font-size: 15px;
    }
    .earnings-value-apr {
        margin-top: 7%;
        font-size: 16px;
    }
    .earnings-value-text {
        font-size: 20px;
    }
    .additional-text {
        margin-top: 7%;
        font-size: 13px;
    }
    .space_text {
        margin-top: 10%;
        font-size: 7px;
    }
}
@media (max-width: 768px) {

    .inviteText {
        font-size: 15px;
    }
    .referralSubContainer {
        padding: 10px;
    }
    .notificationImage {
        width: 25%;
        height: auto;
    }
    .loans-circle {
        width: 20%;
        height: 20%;
    }
    .account-circle {
        width: 22%;
        height: 22%;
    }
    .invest-circle {
        width: 21%;
        height: 21%;
    }
    .reward-circle {
        width: 15%;
        height: 15%
    }

    .earning-circle {
        height: 38%;
        width: 38%
    }

    .loans_wrapper {
        position: absolute;
        top: -15%;
        left: 55%;
        width: 100%;
    }
    .reward_wrapper {
        position: absolute;
        top: 45%;
        left: 72%;
        width: 100%;
    }
    .account_wrapper {
        position: absolute;
        top: 95%;
        left: 20%;
        width: 100%;
    }
    .invest_wrapper {
        position: absolute;
        top: 12%;
        left: 8%;
        width: 100%;
    }
    .normal_circle {
        position: absolute;
        top: 20%;
        left: 15%;
        height: 14vw;
        width: 14vw;
        background: #030092 10%;
        opacity: 0.1;
        box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
        border-radius: 50%;
        display: inline-block;
    }
    .normal_circle_1 {
        position: absolute;
        top: 95%;
        left: 62%;
        height: 12vw;
        width: 12vw;
        background: #030092 10%;
        opacity: 0.1;
        box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
        border-radius: 50%;
        display: inline-block;
    }
    .normal_circle_2 {
        position: absolute;
        top: 5%;
        left: 35%;
        height: 8vw;
        width: 8vw;
        background: #030092 10%;
        opacity: 0.1;
        box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
        border-radius: 50%;
        display: inline-block;
    }
    .normal_circle_3 {
        position: absolute;
        top: 80%;
        left: 72%;
        height: 4vw;
        width: 4vw;
        background: #030092 10%;
        opacity: 0.1;
        box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
        border-radius: 50%;
        display: inline-block;
    }
    .normal_circle_4 {
        position: absolute;
        top: 80%;
        left: 20%;
        height: 4vw;
        width: 4vw;
        background: #030092 10%;
        opacity: 0.1;
        box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
        border-radius: 50%;
        display: inline-block;
    }
      .account-value-static {
        margin-top: 10%;
        font-size: 15px;
    }
    .account-value-text {
        font-size: 18px;
    }
    .additional-text {
        margin-top: 4%;
        font-size: 13px;
    }
    .space_text {
        margin-top: 10%;
        font-size: 6px;
    }
    .earnings-value-static {
        margin-top: 9%;
        font-size: 13px;
    }
    .earnings-value-apr {
        margin-top: 9%;
        font-size: 13px;
    }
    .earnings-value-text {
        font-size: 18px;
    }
    .sub-component {
        margin-top: 150px
    }
}

@media (max-width: 480px) {

    .referralContainer {
        margin-bottom: 50px;
    }
    .notificationImage {
        width: 25%;
        height: auto;
    }
    .inviteText {
        font-size: 15px;
    }
    .referralSubContainer {
        width: 100% !important;
        padding: 10px;
        padding-left: 15px;
        padding-right: 15px;
    }
    .earnings_wrapper {
        padding-top:20% !important;
    }
    .loans-circle {
        width: 37%;
        height: 37%;
    }
    .account-circle {
        width: 39%;
        height: 39%;
    }
    .invest-circle {
        width: 35%;
        height: 35%;
    }
    .reward-circle {
        width: 28%;
        height: 28%
    }

    .earning-circle {
        height: 55%;
        width: 55%
    }

    .loans_wrapper {
        position: absolute;
        top: -10%;
        left: 65%;
        width: 100%;
    }
    .reward_wrapper {
        position: absolute;
        top: 76%;
        left: 75%;
        width: 100%;
    }
    .account_wrapper {
        position: absolute;
        top: 100%;
        left: 10%;
        width: 100%;
    }
    .invest_wrapper {
        position: absolute;
        top: -10%;
        left: 0%;
        width: 100%;
    }
    .space_text {
        margin-top: 9%;
        font-size: 10px;
    }
    .normal_circle {
        position: absolute;
        top: 18%;
        left: 1%;
        height: 20vw;
        width: 20vw;
        background: #030092 10%;
        opacity: 0.1;
        box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
        border-radius: 50%;
        display: inline-block;
    }
    .normal_circle_1 {
        position: absolute;
        top: 105%;
        left: 58%;
        height: 15vw;
        width: 15vw;
        background: #030092 10%;
        opacity: 0.1;
        box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
        border-radius: 50%;
        display: inline-block;
    }
    .normal_circle_2 {
        position: absolute;
        top: 10%;
        left: 37%;
        height: 7vw;
        width: 7vw;
        background: #030092 10%;
        opacity: 0.1;
        box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
        border-radius: 50%;
        display: none;
    }
    .normal_circle_3 {
        position: absolute;
        top: 48%;
        left: 84%;
        height: 10vw;
        width: 10vw;
        background: #030092 10%;
        opacity: 0.1;
        box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
        border-radius: 50%;
        display: inline-block;
    }
    .normal_circle_4 {
        position: absolute;
        top: 80%;
        left: 10%;
        height: 5vw;
        width: 5vw;
        background: #030092 10%;
        opacity: 0.1;
        box-shadow: 0px -20px 50px rgba(173,191,255,0.53) inset;
        border-radius: 50%;
        display: inline-block;
    }
    .account-value-static {
        margin-top: 12%;
        font-size: 13px;
    }
    .account-value-text {
        font-size: 17px;
    }
    .additional-text {
        margin-top: 4%;
        font-size: 10px;
    }
    .earnings-value-static {
        margin-top: 14%;
        font-size: 13px;
    }
    .earnings-value-apr {
        margin-top: 6%;
        font-size: 17px;
    }
    .earnings-value-text {
        font-size: 26px;
    }
    .sub-component {
        margin-top: calc(69% - 60px);
    }
    .rupeeSymbol {
        font-size: 23px
    }

    .rupeeSymbolSmall {
        font-size: 15px !important
    }
    .emptyLoans {
        margin-top: 0% !important;
    }
}
</style>
